import { c as _c } from "react/compiler-runtime";
/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from "@tanstack/react-query";
import { useProjectupdateContext, ProjectupdateContext } from "./projectupdateContext";
import type * as Fetcher from "./projectupdateFetcher";
import { projectupdateFetch } from "./projectupdateFetcher";
import type * as Schemas from "./projectupdateSchemas";
export type ProjectUpdateBookingQualificationQueryParams = {
  projectId?: string;
  leadId?: string;
  partnerId?: string;
  qualificationStep?: Schemas.BookingQualificationStep;
  dealId?: string;
};
export type ProjectUpdateBookingQualificationError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateBookingQualificationVariables = {
  body: Schemas.BookingQualification;
  queryParams?: ProjectUpdateBookingQualificationQueryParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateBookingQualification = (variables: ProjectUpdateBookingQualificationVariables, signal?: AbortSignal) => projectupdateFetch<Schemas.BookingQualificationResponse, ProjectUpdateBookingQualificationError, Schemas.BookingQualification, {}, ProjectUpdateBookingQualificationQueryParams, {}>({
  url: "/booking-qualification",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateBookingQualification = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateBookingQualification({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateBookingCalendarShownPathParams = {
  leadId: string;
};
export type ProjectUpdateBookingCalendarShownError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateBookingCalendarShownVariables = {
  pathParams: ProjectUpdateBookingCalendarShownPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateBookingCalendarShown = (variables: ProjectUpdateBookingCalendarShownVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateBookingCalendarShownError, undefined, {}, {}, ProjectUpdateBookingCalendarShownPathParams>({
  url: "/{leadId}/booking-calendar-shown",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateBookingCalendarShown = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateBookingCalendarShown({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateBookingReconfirmationFormShownPathParams = {
  leadId: string;
  projectId: string;
};
export type ProjectUpdateBookingReconfirmationFormShownError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateBookingReconfirmationFormShownVariables = {
  pathParams: ProjectUpdateBookingReconfirmationFormShownPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateBookingReconfirmationFormShown = (variables: ProjectUpdateBookingReconfirmationFormShownVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateBookingReconfirmationFormShownError, undefined, {}, {}, ProjectUpdateBookingReconfirmationFormShownPathParams>({
  url: "/{leadId}/projects/{projectId}/booking-reconfirmation-form-shown",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateBookingReconfirmationFormShown = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateBookingReconfirmationFormShown({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateMedalFlowBookingIntentPathParams = {
  leadId: string;
  projectId: string;
};
export type ProjectUpdateMedalFlowBookingIntentError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateMedalFlowBookingIntentVariables = {
  pathParams: ProjectUpdateMedalFlowBookingIntentPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateMedalFlowBookingIntent = (variables: ProjectUpdateMedalFlowBookingIntentVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateMedalFlowBookingIntentError, undefined, {}, {}, ProjectUpdateMedalFlowBookingIntentPathParams>({
  url: "/{leadId}/projects/{projectId}/medal-flow-booking-intent",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateMedalFlowBookingIntent = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateMedalFlowBookingIntent({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateReactivateProjectPathParams = {
  leadId: string;
  projectId: string;
};
export type ProjectUpdateReactivateProjectError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateReactivateProjectVariables = {
  pathParams: ProjectUpdateReactivateProjectPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateReactivateProject = (variables: ProjectUpdateReactivateProjectVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateReactivateProjectError, undefined, {}, {}, ProjectUpdateReactivateProjectPathParams>({
  url: "/{leadId}/projects/{projectId}/reactivate",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateReactivateProject = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateReactivateProject({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateMedalFlowPathParams = {
  projectId: string;
  leadId: string;
};
export type ProjectUpdateMedalFlowQueryParams = {
  prequalificationUtmSource?: Schemas.PrequalificationUtmSource;
};
export type ProjectUpdateMedalFlowError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateMedalFlowVariables = {
  body: Schemas.MedalFlowInfo;
  pathParams: ProjectUpdateMedalFlowPathParams;
  queryParams?: ProjectUpdateMedalFlowQueryParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateMedalFlow = (variables: ProjectUpdateMedalFlowVariables, signal?: AbortSignal) => projectupdateFetch<Schemas.BookingQualificationResponse, ProjectUpdateMedalFlowError, Schemas.MedalFlowInfo, {}, ProjectUpdateMedalFlowQueryParams, ProjectUpdateMedalFlowPathParams>({
  url: "/{leadId}/projects/{projectId}/medal-flow",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateMedalFlow = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateMedalFlow({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type GetMedalFlowQualificationPathParams = {
  leadId: string;
  projectId: string;
};
export type GetMedalFlowQualificationError = Fetcher.ErrorWrapper<undefined>;
export type GetMedalFlowQualificationVariables = {
  pathParams: GetMedalFlowQualificationPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchGetMedalFlowQualification = (variables: GetMedalFlowQualificationVariables, signal?: AbortSignal) => projectupdateFetch<Schemas.MedalFlowQualificationStatus, GetMedalFlowQualificationError, undefined, {}, {}, GetMedalFlowQualificationPathParams>({
  url: "/{leadId}/projects/{projectId}/medal-flow/qualification",
  method: "get",
  ...variables,
  signal
});
export const useGetMedalFlowQualification = (variables, options) => {
  const $ = _c(11);
  const {
    fetcherOptions,
    queryOptions,
    queryKeyFn
  } = useProjectupdateContext(options);
  let t0;
  if ($[0] !== queryKeyFn || $[1] !== variables) {
    t0 = queryKeyFn({
      path: "/{leadId}/projects/{projectId}/medal-flow/qualification",
      operationId: "getMedalFlowQualification",
      variables
    });
    $[0] = queryKeyFn;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== fetcherOptions || $[4] !== variables) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchGetMedalFlowQualification({
        ...fetcherOptions,
        ...variables
      }, signal);
    };
    $[3] = fetcherOptions;
    $[4] = variables;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== options || $[7] !== queryOptions || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options,
      ...queryOptions
    };
    $[6] = options;
    $[7] = queryOptions;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return reactQuery.useQuery(t2);
};
export type ProjectUpdateSilverFlowStartPathParams = {
  projectId: string;
  leadId: string;
};
export type ProjectUpdateSilverFlowStartQueryParams = {
  prequalificationUtmSource?: Schemas.PrequalificationUtmSource;
};
export type ProjectUpdateSilverFlowStartError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateSilverFlowStartVariables = {
  pathParams: ProjectUpdateSilverFlowStartPathParams;
  queryParams?: ProjectUpdateSilverFlowStartQueryParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateSilverFlowStart = (variables: ProjectUpdateSilverFlowStartVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateSilverFlowStartError, undefined, {}, ProjectUpdateSilverFlowStartQueryParams, ProjectUpdateSilverFlowStartPathParams>({
  url: "/{leadId}/projects/{projectId}/silver-flow-start",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateSilverFlowStart = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateSilverFlowStart({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type ProjectUpdateMedalFlowCompletionPathParams = {
  projectId: string;
  leadId: string;
};
export type ProjectUpdateMedalFlowCompletionError = Fetcher.ErrorWrapper<undefined>;
export type ProjectUpdateMedalFlowCompletionVariables = {
  body?: Schemas.MedalFlowCompletion;
  pathParams: ProjectUpdateMedalFlowCompletionPathParams;
} & ProjectupdateContext["fetcherOptions"];
export const fetchProjectUpdateMedalFlowCompletion = (variables: ProjectUpdateMedalFlowCompletionVariables, signal?: AbortSignal) => projectupdateFetch<undefined, ProjectUpdateMedalFlowCompletionError, Schemas.MedalFlowCompletion, {}, {}, ProjectUpdateMedalFlowCompletionPathParams>({
  url: "/{leadId}/projects/{projectId}/medal-flow-completion",
  method: "post",
  ...variables,
  signal
});
export const useProjectUpdateMedalFlowCompletion = options => {
  const $ = _c(5);
  const {
    fetcherOptions
  } = useProjectupdateContext();
  let t0;
  if ($[0] !== fetcherOptions) {
    t0 = variables => fetchProjectUpdateMedalFlowCompletion({
      ...fetcherOptions,
      ...variables
    });
    $[0] = fetcherOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      mutationFn: t0,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return reactQuery.useMutation(t1);
};
export type QueryOperation = {
  path: "/{leadId}/projects/{projectId}/medal-flow/qualification";
  operationId: "getMedalFlowQualification";
  variables: GetMedalFlowQualificationVariables;
};